/* eslint-disable no-param-reassign */

xplenty.filter('lengthCheck', [
  function () {
    return function (txt, len, suffix) {
      let output = '';
      txt = txt || output;
      suffix = suffix || '...';

      if (txt.length > len) {
        output = txt.substr(0, len) + suffix;
      } else {
        output = txt;
      }

      return output;
    };
  },
]);
